/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente CustomModal
 */
export const CustomModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 380px;
  transform: translate(-50%, -50%);
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 1650)};

  .MuiPaper-root {
    width: ${({ viewWidth }) => (viewWidth ? viewWidth + 'px' : '100%')};
    height: 100%;
    border-radius: 2px;
    padding: 0px 35px 30px;
  }

  .close_bt {
    position: absolute;
    top: 11px;
    right: 6px;
    border: none;
    background: none;

    &:hover {
      border: none;
    }
  }

  .header {
    padding-top: 30px;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 12px;
    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      color: #5e6366;
    }
  }

  .body {
    padding-top: 32px;

    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 16px;
      color: #5e6366;
    }
  }
`;
